import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import BookListBody from "../BookListBody/BookListBody";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import BookListFilter from "../BookListFilter/BookListFilter";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import AddBookList from "../AddBookList/AddBookList";
import { url } from "../../../../../Config/Config";
import Axios from "axios";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewBookList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 5,
      page: 0,
      searchBy: {
        title: "",
      },
      column: [
        { name: "S.N" },
        { name: "Book Title" },
        { name: "Copies Available" },
        { name: "Current Available" },
        { name: "ISBN" },
        { name: "Author" },
        { name: "Category" },
        { name: "Publication" },
        { name: "Actions" },
      ],
      books: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getBookList();
  }

  getBookList = async () => {
    try {
      const response = await Axios.get(`${url}/api/books`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.books.length !== 0) {
        this.setState({ books: response.data.books, isEmpty: false });
      } else {
        this.setState({ books: [], isEmpty: true });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getBookList();
      }
    }
  };

  handleSearch = (e) => {
    this.setState({
      searchBy: {
        ...this.state.searchBy,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;

    const filtered = this.state.books.filter((book) => {
      return (
        book.title
          .toLowerCase()
          .indexOf(this.state.searchBy.title.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Book List" refreshUrl={this.props.match.url} />

          <BookListFilter
            data={this.state.searchBy}
            handleSearch={this.handleSearch}
          />

          <TableContainer>
            <Table>
              <CustomTableHead column={this.state.column} />

              <TableBody>
                <AddBookList getBookList={this.getBookList} />
                {filtered
                  .slice(rowsPerPage * page, rowsPerPage * page + rowsPerPage)
                  .map((book, index) => (
                    <BookListBody
                      data={book}
                      key={index}
                      index={index}
                      getBookList={this.getBookList}
                    />
                  ))}
              </TableBody>

              <CustomTableFooter
                count={filtered.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={this.handlePage}
                onChangeRowsPerPage={this.handleRowsPerPage}
              />
            </Table>
          </TableContainer>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewBookList)));
